/*
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-10-28 18:30:59
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-21 18:41:10
 * @FilePath: /wemeet-admin-new/src/config/net.config.js
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
 */

const BASE_URL_DEV = 'https://api-dev.wemeet.com' // 开发环境接口地址
// const BASE_URL_DEV = 'https://jos.wemeet.com'
const BASE_URL_PROD = 'https://jos.wemeet.com'

let isProd = process.env.NODE_ENV === 'production'
// isProd = true

/**
 * @description 导出网络配置
 **/
module.exports = {
  // 默认的接口地址，开发环境和生产环境都会走/vab-mock-server
  // 正式项目可以选择自己配置成需要的接口地址，如"https://api.xxx.com"
  // 问号后边代表开发环境，冒号后边代表生产环境'http://192.168.31.19:9900'
  // 问号后边代表开发环境，冒号后边代表生产环境 'http://192.168.31.11:9900'
  // 正式环境接口地址 https://jos.wemeet.com   https://api-dev.wemeet.com https://api-uat.wemeet.com
  baseURL: isProd ? BASE_URL_PROD : BASE_URL_DEV,
  // 配后端数据的接收方式application/json;charset=UTF-8 或 application/x-www-form-urlencoded;charset=UTF-8
  contentType: 'application/json;charset=UTF-8',
  // 最长请求时间
  requestTimeout: 1800000, // 半小时
  // 操作正常code，支持String、Array、int多种类型
  successCode: [200, 0, '200', '0'],
  // 数据状态的字段名称
  statusName: 'code',
  // 状态信息的字段名称
  messageName: 'msg',
  baseH5URL: isProd ? 'https://v.wemeet.com/#' : 'https://wemeet-h5-dev.wemeet.com/#',
  _baseH5URL: isProd ? 'https://wemeet-h5.wemeet.com/#' : 'https://wemeet-h5-dev.wemeet.com/#',
  baseAiURL: isProd ? 'https://www.wemeetai.cn' : 'https://test-www.wemeetai.cn',
}
